import { useEffect, useState } from 'react'

export function useMotionEnabled() {
  const [on, setOn] = useState(() => {
    if (typeof window === 'undefined') return true
    const mq = window.matchMedia?.('(prefers-reduced-motion: reduce)')
    return !mq?.matches
  })
  useEffect(() => {
    const mq = window.matchMedia?.('(prefers-reduced-motion: reduce)')
    if (!mq) return
    const onChange = () => setOn(!mq.matches)
    mq.addEventListener?.('change', onChange)
    return () => mq.removeEventListener?.('change', onChange)
  }, [])
  return on
}
